export default {
  TAX_PROVISION: 'menus.taxProvision.subMenu.provision',
  BATCH_PROVISION: 'menus.taxProvision.subMenu.batchProvision',

  BEGINNING_BALANCES: 'menus.administration.subMenu.beginningBalances',
  BUSINESS_UNIT_SETTINGS: 'menus.administration.subMenu.businessUnitSettings',
  TAX_ACCOUNTING_SETTINGS: 'menus.administration.subMenu.taxAccountingSettings',
  TAX_BOOKING_ENTITIES: 'menus.administration.subMenu.taxBookingEntities',
  TLS_ACCOUNT_SETTINGS: 'menus.administration.subMenu.tlsAccountSettings',
  ACCOUNT_TAGS: 'menus.administration.subMenu.applicationAdministration.subMenu.accountTags',
  DATABASE_LOGS: 'menus.administration.subMenu.databaseLogs',
  LEGAL_ENTITY_SETTINGS: 'menus.administration.subMenu.legalEntitySettings',
  OBLIGATIONS: 'menus.administration.subMenu.obligations',
  CORRECTING_ENTRY_LIST_PAGE: 'menus.administration.subMenu.balanceSheetManagement.subMenu.correctingEntryList',
  GL_ACCOUNT_LIST_PAGE: 'menus.administration.subMenu.balanceSheetManagement.subMenu.GLAccountList',
  ACCOUNT_MAP_PAGE: 'menus.administration.subMenu.balanceSheetManagement.subMenu.AccountMap',
  SL_ACCOUNTS_PAGE: 'menus.administration.subMenu.balanceSheetManagement.subMenu.SlAccountsPage',
  GL_JOURNALS_PAGE: 'menus.administration.subMenu.balanceSheetManagement.subMenu.GlJournalsPage',
  USER_ADMINISTRATION: 'menus.administration.subMenu.userAdministration',
  CURRENCY_CONVERSION_RATES: 'menus.administration.subMenu.currencyConversionRates',
  COMPANY_CODES: 'menus.administration.subMenu.companyCodes',
  CUSTOM_GROUPS: 'menus.administration.subMenu.customGroups',
  NOL_VA: 'menus.administration.subMenu.nolVa',
  BALANCE_SHEET_MANAGEMENT_ADMIN: 'menus.administration.subMenu.balanceSheetManagement',
  CHART_OF_ACCOUNTS: 'menus.administration.subMenu.chartOfAccounts',
  TRIAL_BALANCE_THRESHOLD: 'menus.administration.subMenu.trialBalanceThreshold',

  BALANCE_SHEET_MANAGEMENT_VIEW: 'menus.balanceSheetManagement',
  ADD_TAX_ENTRY: 'menus.balanceSheetManagement.subMenu.addTaxEntries',
  BATCH_TAX_ENTRIES: 'menus.balanceSheetManagement.subMenu.batchTaxEntries',
  BATCH_RATE_CHANGE_WORKPAPER: 'menus.balanceSheetManagement.subMenu.viewRateChangeWorkpaper',
  RECLASS_BALANCES: 'menus.balanceSheetManagement.subMenu.reclassBalances',

  TAX_RATES: 'menus.administration.subMenu.taxRates',
  BOOK_TO_TAX_DIFFERENCE: 'menus.administration.subMenu.bookToTaxDifference',

  APPLICATION_SETTINGS: 'menus.administration.subMenu.applicationAdministration.subMenu.applicationSettings',
  E2E_HEALTHCHECK: 'menus.administration.subMenu.e2eHealthcheck',
  CATEGORIES_AND_TAGS: 'menus.administration.subMenu.categoriesAndTags',
  CUSTOM_REPORTS: 'menus.reports.subMenu.customReports',
  APPLICATION_ADMINISTRATION: 'menus.administration.subMenu.applicationAdministration',

  CLIENT: 'menus.administration.subMenu.applicationAdministration.subMenu.client',
  ADMIN_TAX_ENTRY: 'menus.administration.subMenu.balanceSheetManagement.subMenu.adminTaxEntry',

  CUSTOM_REPORTS_MANAGEMENT: 'menus.administration.subMenu.applicationAdministration.subMenu.customReportsManagement',
  COMMUNICATIONS: 'menus.dashboard.communications',

  CLIENT_ADMININISTRATION: 'menus.administration.subMenu.clientAdministration',

  DIAGNOSTICS: 'menus.administration.subMenu.diagnostics',

  SCENARIOS: 'menus.scenarios',
  RETURN_TO_PROVISION: 'menu.returnToProvision',

  HELP: 'help',
};
